const ACRONYMS = '';
module.exports = { ACRONYMS };